import { Commit, Dispatch } from 'vuex';
import { DemandeInterventionState } from './state';


export interface InterventionModuleActionTypes{
    commit: Commit,
    state: DemandeInterventionState,
    getters: any,
    dispatch: Dispatch,
}

export enum InterventionModuleAction{
    SEND_ASK_INTERVENTION = 'INTERVENTION_SEND_ASK_INTERVENTION',
    PREFILL_CONTACTS_SUIVI = 'PREFILL_CONTACTS_SUIVI',
    PREFILL_CONNECTED_CONTACT_SUIVI = 'PREFILL_CONNECTED_CONTACT_SUIVI',
    SHOW_ASTREINTE_MODALE = 'SHOW_ASTREINTE_MODALE'
}
